import $ from 'jquery';
import VideoPlayer from './shared/videoPlayer';
import FileDownloader from './shared/fileDownloader';
import BranchPage from './pages/branchPage';
import TestimonialsWidget from './shared/testimonialsWidget';
import JobOpenings from './pages/jobOpenings';

export default class PageManaer {
    constructor(page) {
        this.$page = page ? page : $('.body >div');

        this.init();
    }

    init() {
        if (this.$page.find('.app-video').length) {
            if (navigator.appVersion.indexOf("Mac") !== -1 || navigator.userAgent.indexOf('MSIE') > 0 || navigator.userAgent.indexOf('Trident/') > 0) {
                let $videoTag = $('video[cmg-app-video]');
                let $videoTagContainer = $videoTag.parent();
                $videoTag.remove();
                $videoTagContainer.append('<img src="https://res.cloudinary.com/dvbdysuf5/image/upload/v1581021662/CMG_Web_Resources/Home_Images/Mobile_Features_wo_Search.gif" alt="Search" />');
            }
        }

        if (this.$page.is('#home_page')) {
            new VideoPlayer();
        }

        if (this.$page.is('#brand_home_page')) {
            new VideoPlayer();
        }

        if (this.$page.is('#branch_page')) {
            new BranchPage();
        }

        if (this.$page.is('#watch_and_learn_page')) {
            new VideoPlayer();
        }

        if (this.$page.is('#recruiting_page')) {
            new VideoPlayer();
        }

        if (this.$page.is('#my_site_page')) {
            new VideoPlayer();
        }

        if (this.$page.is('#all_in_one_page_corporate')) {
            new VideoPlayer();
        }

        if (this.$page.is('#all_in_one_page')) {
            new VideoPlayer();
        }
        else if (this.$page.is('#happyemployees-page')) {
            new VideoPlayer();
        }  else if (this.$page.is('#happypartners-page')) {
            new VideoPlayer();
        }

        if (this.$page.is('#cmg_cares_page')) {
            new VideoPlayer();
        }

        if ($('.testimonials-widget-component').length) {
            new TestimonialsWidget();
        }

        if (this.$page.is('#blog_page')) {
            new VideoPlayer();
        }

        if (this.$page.is('#partner_home_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#jv_videos_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#jv_customized_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#ceo_chats_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#upload_video_testimonials')) {
            new VideoPlayer();
        }

        if (this.$page.is('#teamPage')) {
            new VideoPlayer();
        }

        if (this.$page.is('#resource_library_page')) {
	        new VideoPlayer();
        }
        if (this.$page.is('#homefundit_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#all-testimonials')) {
            new VideoPlayer();
        }
        if (this.$page.is('#team-all-testimonials')) {
            new VideoPlayer();
        }
        if (this.$page.is('#video_landing_page')) {
            new VideoPlayer();
        }

        if (this.$page.is('#careers_page')) {
            new VideoPlayer();
        }

        if (this.$page.is('#job-openings_page')) {
            new JobOpenings();
        }
        if (this.$page.is('#jv_recruiting_home_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#jv_recruiting_video_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#cf_lp_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#recruiting_vip_video_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#locknlist_landing_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#locknlist_home_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#builder_home_page')) {
            new VideoPlayer();
        }

        if (this.$page.is('#locknlist_confirmation_page')) {
            if ($('[data-role="video-player"]').length && !$('[data-role="video-player"]').is('.pending'))
                new VideoPlayer();
        }

        if (this.$page.is('#speclock_confirmation_page')) {
            if ($('[data-role="video-player"]').length && !$('[data-role="video-player"]').is('.pending'))
                new VideoPlayer();
        }

        if (this.$page.is('#speclock_builder_confirmation_page')) {
            if ($('[data-role="video-player"]').length && !$('[data-role="video-player"]').is('.pending'))
                new VideoPlayer();
        }

        if (this.$page.is('#builderforward_builder_confirmation_page')) {
            if ($('[data-role="video-player"]').length && !$('[data-role="video-player"]').is('.pending'))
                new VideoPlayer();
        }

        if (this.$page.is('#builderforward_confirmation_page')) {
            if ($('[data-role="video-player"]').length && !$('[data-role="video-player"]').is('.pending'))
                new VideoPlayer();
        }

        if (this.$page.is('#test_page')) {
            if ($('[data-role="video-player"]').length && !$('[data-role="video-player"]').is('.pending'))
                new VideoPlayer();
        }

        if (this.$page.is('#ll_property_page')) {
            if ($('[data-role="video-player"]').length && !$('[data-role="video-player"]').is('.pending'))
                new VideoPlayer();
        }

        if (this.$page.is('#search_rate_result_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#builders_new_page')) {
            new VideoPlayer();
        }
        if (this.$page.is('#mysite_builders_new_page')) {
            new VideoPlayer();
        }
    }
}